export const THEMES = {
  ROCKET: 'ROCKET',
  LIGHT: 'LIGHT'
};
